import LoadingLottie from '@assets/lottie/jooice-loader.json';
import { Stack } from '@mui/material';
import Lottie from 'lottie-react';

export default function SplashLoader() {
  return (
    <Stack width="100%" height="100%" justifyContent="center" alignItems="center">
      <Lottie autoplay style={{ width: 300 }} animationData={LoadingLottie} loop={true} />
    </Stack>
  );
}
